import { useHistory } from 'react-router';

import { api } from '../../../../api';
import { TabNav, TabNavItem } from '../../../../v2/common/TabNav';
import { BASE_ACCOUNT_PATH, accountLinkMap } from './constants';

export const AccountPageNav = () => {
  const { location, push } = useHistory();
  if (location.pathname === BASE_ACCOUNT_PATH) {
    push(accountLinkMap[0].to);
  }

  const { data: details } = api.account.details.useQuery();

  const links = !details || details.userType === 'Lead' ? [accountLinkMap[1]] : accountLinkMap;

  const tabs: TabNavItem<string>[] = links.map((link) => ({ value: link.to, label: link.name }));

  return (
    <div className="mb-4">
      <TabNav tabs={tabs} activeTab={location.pathname} onTabChange={push} ariaLabel="Account sections" />
    </div>
  );
};
export default AccountPageNav;
